import { Flex, MenuListItem } from '@cad-arc';
import classnames from 'classnames';
import { NotificationCounter } from '../../common/components/notification-counter';
import styles from './conversations-subpanel.module.css';
import { Tooltip } from '~/common/components/tooltip';

export const ConversationItem: React.FC<{
    allOtherMembersLabel: string;
    allOtherMembersTooltip: string;
    senderParticipantLabel: string;
    lastMessageDateTimeDisplay: string;
    unreadCount?: number;
    isSelected?: boolean;
    hasUrgentUnread?: boolean;
    onConversationItemClick?: () => void;
    'data-testconversationkey'?: string;
    showUnread: boolean;
}> = (props) => {
    const {
        allOtherMembersLabel,
        allOtherMembersTooltip,
        senderParticipantLabel,
        lastMessageDateTimeDisplay,
        unreadCount,
        isSelected,
        hasUrgentUnread,
        onConversationItemClick,
        showUnread,
    } = props;
    return (
        <MenuListItem
            data-testid="conversation-button"
            data-testconversationkey={props['data-testconversationkey']}
            {...(isSelected ? { 'data-isselected': true } : undefined)}
            className={classnames(styles['conversation-item'], {
                [styles['is-selected']]: !!isSelected,
            })}
            onClick={onConversationItemClick}
        >
            <div
                className={classnames(styles['conversation-title'], {
                    [styles['has-unread']]: showUnread && unreadCount && unreadCount > 0,
                })}
            >
                <Flex
                    justifyContent="space-between"
                    width="100%"
                    lineHeight="var(--arc-lineHeights-short)"
                >
                    <Tooltip overlay={allOtherMembersLabel} placement="right" mouseEnterDelay={0.4}>
                        <span
                            className={classnames(styles['left'], {
                                [styles['is-selected']]: !!isSelected,
                            })}
                        >
                            {allOtherMembersTooltip}
                        </span>
                    </Tooltip>
                    <span className={styles['right']}>{lastMessageDateTimeDisplay}</span>
                </Flex>
            </div>
            <div className={styles['conversation-description']}>
                <span className={styles['left']}>{senderParticipantLabel}</span>
                <span className={styles['right']} data-testid="unread-counter">
                    {showUnread && !!unreadCount && (
                        <NotificationCounter isUrgent={!!hasUrgentUnread}>
                            {unreadCount}
                        </NotificationCounter>
                    )}
                </span>
            </div>
        </MenuListItem>
    );
};
